/* ============================================================
   Banda de cashback personalizable · Rebuy Smart Cart
   Getmore · 14.07.26

   v3 — 15.07.26: DESACOPLADO por completo de Rebuy. La v2 hacia
   hijack del bloque nativo de Rebuy
   ([data-rebuy-component="content-block"].rebuy-cart__content-block--top),
   que solo existe en el DOM si ese content block esta activo desde
   el admin de Rebuy. Eso significaba que apagar/prender ese content
   block en Rebuy apagaba o prendia esta banda sin querer, aunque
   cashback_banner_enabled del theme editor siguiera en true.

   Ahora el script crea su PROPIO contenedor (#tc-cashback-banner-wrapper)
   y lo inserta como primer hijo de data-rebuy-cart-scroll-area, sin
   tocar ni depender de ningun elemento de Rebuy. El unico switch real
   es cashback_banner_enabled en la seccion "Rebuy Smart Cart".

   Toma titulo/subtitulo/disclaimer/colores del script JSON que
   imprime la seccion (editables en el theme editor). Se reinyecta en
   cada render porque Rebuy reconstruye su DOM al actualizar el carrito
   (y con eso borra nuestro wrapper tambien).
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR_SCROLL_AREA = '#rebuy-cart [data-rebuy-cart-scroll-area]';
  var DATA_EL_ID = 'tc-cashback-banner-data';
  var BANNER_ID = 'tc-cashback-banner-wrapper';

  var data = null;
  try {
    var raw = document.getElementById(DATA_EL_ID);
    if (raw) data = JSON.parse(raw.textContent);
  } catch (e) { /* noop */ }

  if (!data) return;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function buildBannerElement() {
    var wrapper = document.createElement('div');
    wrapper.id = BANNER_ID;
    wrapper.className = 'tc-cashback-banner';
    wrapper.style.backgroundColor = data.background || '';
    wrapper.style.color = data.textColor || '';

    var html = '';
    if (data.title) {
      html += '<p class="tc-cashback-banner__title">' + escapeHtml(data.title) + '</p>';
    }
    if (data.subtitle) {
      html += '<p class="tc-cashback-banner__subtitle">' + escapeHtml(data.subtitle) + '</p>';
    }
    if (data.disclaimer) {
      html += '<p class="tc-cashback-banner__disclaimer">' + escapeHtml(data.disclaimer) + '</p>';
    }
    wrapper.innerHTML = html;
    return wrapper;
  }

  function build() {
    var scrollArea = document.querySelector(SELECTOR_SCROLL_AREA);
    if (!scrollArea) return;

    var existing = document.getElementById(BANNER_ID);

    /* Ya esta insertado y sigue siendo el primer hijo: nada que hacer. */
    if (existing && scrollArea.contains(existing)) {
      if (scrollArea.firstElementChild !== existing) {
        scrollArea.insertBefore(existing, scrollArea.firstChild);
      }
      return;
    }

    /* Rebuy reconstruyo el DOM y se llevo nuestro wrapper: recrearlo. */
    if (existing) existing.remove();

    var wrapper = buildBannerElement();
    scrollArea.insertBefore(wrapper, scrollArea.firstChild);
  }

  function schedule() {
    if (schedule._t) clearTimeout(schedule._t);
    schedule._t = setTimeout(build, 100);
  }

  [
    'rebuy:cart.ready',
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.remove',
    'rebuy:cart.increase',
    'rebuy:cart.decrease',
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show'
  ].forEach(function (evt) {
    document.addEventListener(evt, schedule);
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var t = m.target;
      /* Ignorar mutaciones causadas por nuestro propio wrapper, para
         no entrar en loop con el insertBefore de arriba. */
      if (t && t.closest && t.closest('.tc-cashback-banner')) continue;
      if (t && t.closest && t.closest('#rebuy-cart')) { schedule(); return; }
      for (var n = 0; n < m.addedNodes.length; n++) {
        var node = m.addedNodes[n];
        if (node.nodeType === 1 && (node.id === 'rebuy-cart' || (node.querySelector && node.querySelector('#rebuy-cart')))) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    schedule();
  } else {
    document.addEventListener('DOMContentLoaded', schedule);
  }
})();
